




























































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import { EventBus } from "@/eventbus";
import EmptyCell from "@/components/EmptyCell.vue";
export default Vue.extend({
  props: ["source"],
  components: {
    AppTableRow,
    EmptyCell,
  },
  setup(props) {
    const showMenu = (event: MouseEvent) =>
      EventBus.emit("showTemplateMenu", { item: props.source, event });

    return {
      showMenu,
    };
  },
});
